import { Grid, Typography } from '@mui/material';
import { TaxConditionsTranslate } from '../../../../models/CustomerEntity';
import { FormControll, Box } from '@arredo/reactjs-ui';

const CustomerInfo = ({ customer }) => {
    return (
        <Box header={
            <Grid container direction='column' size={12}>
                <Typography>
                    Datos del cliente
                </Typography>
            </Grid>
        }
        >
            <Grid size={12}>
                <Grid container spacing={1} direction='column'>

                    <Grid container spacing={1} direction='column' size={12}>
                        <Grid size={12}>
                            <FormControll item size={12} label='Cliente' value={customer?.id} />
                            <FormControll item size={12} label='Nombre' value={customer ? `${customer.lastName ? customer.lastName + ', ' : ''} ${customer.firstName}` : ""} />
                            <FormControll item size={12} label={customer?.documentType} value={customer?.documentNumber} />
                            <FormControll item size={12} label='Condición Impositiva' value={TaxConditionsTranslate[customer?.taxCondition]} />
                            <FormControll item size={12} label='Email' value={customer?.email} />
                            <FormControll item size={12} label='Teléfono' value={customer?.phone || '-'} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
export default CustomerInfo